import { isLocalhost } from '../common/v2/environment/utils';

declare global {
  interface Console {
    log2: typeof console.log;
  }
}

export const bootstrapApp = () => {
  console.log2 = function (...args: any[]) {
    try {
      console.log(...JSON.parse(JSON.stringify(args)));
    } catch (e) {
      // sometimes there could be errors if the items in args[] are not serializable in JSON
      console.log(...args);
    }
  };

  if (!isLocalhost) {
    console.log = () => null;
    console.log2 = () => null;
  }
};
